
// Consolidate auth hook exports
import { useContext } from 'react';
import { AuthContext } from './auth/AuthContext';
import type { AuthContextType, Profile } from '../types/auth';

export const useAuth = () => useContext(AuthContext);

export default useAuth;
export type { AuthContextType, Profile };
